import { render, staticRenderFns } from "./ProgramaSubirForm.vue?vue&type=template&id=3fed9937"
import script from "./ProgramaSubirForm.vue?vue&type=script&lang=js"
export * from "./ProgramaSubirForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports